export default __webpack_public_path__ + "static/media/ligth.f9837e77.png";